/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Needhelp1Inputs */

const en_btn_needhelp1 = /** @type {(inputs: Btn_Needhelp1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Need help?`)
};

/**
* | output |
* | --- |
* | "Need help?" |
*
* @param {Btn_Needhelp1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const btn_needhelp1 = /** @type {((inputs?: Btn_Needhelp1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Needhelp1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_needhelp1(inputs)
});
export { btn_needhelp1 as "btn_needHelp" }